import type { Article } from "@/mocks/articles";
import { CategoryTag } from "@/components/feature/ArticleCard";

export default function ArticleHeader({ article }: { article: Article }) {
  return (
    <header className="mx-auto max-w-content px-4 pt-8 md:px-6 md:pt-10">
      <div className="mx-auto max-w-3xl">
        <div className="flex flex-wrap items-center gap-2">
          <CategoryTag slug={article.categorySlug} name={article.category} />
          {article.featured && (
            <span className="inline-flex items-center gap-1 rounded-md bg-primary-50 px-2 py-0.5 text-[11px] font-medium text-primary-700">
              <i className="ri-bookmark-3-line"></i>
              深扒
            </span>
          )}
        </div>

        <h1 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
          {article.title}
        </h1>

        <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
          {article.excerpt}
        </p>

        <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 border-y border-background-200 py-4 text-xs text-foreground-500 md:text-sm">
          <span className="flex items-center gap-1.5">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-user-3-line"></i>
            </span>
            {article.author}
          </span>
          <span className="flex items-center gap-1.5">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-calendar-line"></i>
            </span>
            {article.date}
          </span>
          <span className="flex items-center gap-1.5">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-eye-line"></i>
            </span>
            {article.views.toLocaleString("zh-CN")} 阅读
          </span>
          <span className="flex items-center gap-1.5">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-timer-line"></i>
            </span>
            约 {article.readingMinutes} 分钟
          </span>
        </div>

        <p className="mt-4 flex items-start gap-2 text-xs text-foreground-500">
          <span className="mt-0.5 flex h-3.5 w-3.5 flex-none items-center justify-center text-secondary-500">
            <i className="ri-links-line"></i>
          </span>
          线索来源：{article.source}
        </p>
      </div>

      <div className="mx-auto mt-8 h-[220px] max-w-4xl overflow-hidden rounded-lg md:h-[400px]">
        <img
          src={article.cover}
          alt={`${article.title} 内容配图`}
          title={`${article.title} - 黑料八卦深扒起底`}
          className="h-full w-full object-cover object-top"
        />
      </div>
    </header>
  );
}